import React from 'react'
import clsx from 'clsx'
//import I18n from 'i18n-js/index.js.erb'
import SeasonalPricePresenter from '../../SeasonPresenter/SeasonalPricePresenter'
class GroupContractPresenterPricing extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var self = this
    var tabClasses = clsx({
      'active': this.props.active_tab == 'pricing',
      'tab-pane': true
    })
    var group_contract_prices = this.props.group_contract_prices.map(group_contract_price => {
      return (
        <div className="group-contract-price">
          <SeasonalPricePresenter
            key={group_contract_price.id}
            {...group_contract_price} 
            nested={true}
            date_format={self.props.date_format}
            time_format={self.props.date_format}
            view_type="group_contract_price" /> 
        </div>
      )
    })
    return (
      <div className={tabClasses} id="pricing">
        {
          this.props.group_contract_prices.length 
            ? group_contract_prices
            : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>
        }
      </div>  
    )
  }
}
export default GroupContractPresenterPricing


